import axios from "axios";

axios
  .get("/settings.json")
  .then(resp => {
    window.appSettings = resp.data;
    return import("./bootstrap");
  })
  .catch(err => {
    console.warn(err);
  });
